module.exports = __webpack_public_path__ + "img/caisse.bcd3a09a.svg";